import BillingsOrderTaxiRailyDraftResponse, {
  BillingsOrderTaxiRailyDraftResponseDataBillingNode,
  BillingsOrderTaxiRailyDraftResponseDataCargoOrder,
  BillingsOrderTaxiRailyDraftResponseDataContract,
  BillingsOrderTaxiRailyDraftResponseDataContractCargoCompany,
} from "../../../../../api/raily/billings/order/taxi-raily/draft/billings-order-taxi-raily-draft.response";
import BillingsOrderTaxiRailyDraft, {
  BillingsOrderTaxiRailyDraftCargoOrder,
  BillingsOrderTaxiRailyDraftContractCargoCompany,
  BillingsOrderTaxiRailyDraftContract,
  BillingsOrderTaxiRailyDraftBillingNode,
} from "./billings-order-taxi-raily-draft";

const createCargoOrder = (
  cargoOrder: BillingsOrderTaxiRailyDraftResponseDataCargoOrder,
): BillingsOrderTaxiRailyDraftCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
    id: cargoOrder.id,
  };
};

const createContractCargoCompany = (
  cargoCompany: BillingsOrderTaxiRailyDraftResponseDataContractCargoCompany,
): BillingsOrderTaxiRailyDraftContractCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
  };
};

const createContract = (
  contract: BillingsOrderTaxiRailyDraftResponseDataContract,
): BillingsOrderTaxiRailyDraftContract => {
  return {
    allowChargeDuringRide: contract.allowChargeDuringRide,
    allowChargeWhileApproaching: contract.allowChargeWhileApproaching,
    allowChargeWhileReturning: contract.allowChargeWhileReturning,
    cargoCompany: createContractCargoCompany(contract.cargoCompany),
    discountLimit: contract.discountLimit,
    distanceRate: contract.distanceRate,
    haltingTimeAfterMinutes: contract.haltingTimeAfterMinutes,
    haltingTimeRate: contract.haltingTimeRate,
    model: contract.model,
  };
};

const createBillingNode = (
  node: BillingsOrderTaxiRailyDraftResponseDataBillingNode,
): BillingsOrderTaxiRailyDraftBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderTaxiRailyDraftResponseDataBillingNode[],
): BillingsOrderTaxiRailyDraftBillingNode[] => {
  return nodes.map(createBillingNode);
};

const create = (
  response: BillingsOrderTaxiRailyDraftResponse,
): BillingsOrderTaxiRailyDraft => {
  const data = response.data;

  return {
    contract: createContract(data.contract),
    billingNodes: createBillingNodes(data.billingNodes),
    cargoOrder: createCargoOrder(data.cargoOrder),
    discount: data.discount,
    discountAmount: data.discountAmount,
    distance: data.distance,
    distanceAmount: data.distanceAmount,
    haltingAmount: data.haltingAmount,
    highwayCharge: data.highwayCharge,
    planEntryId: data.planEntryId,
    totalAmount: data.totalAmount,
  };
};

const billingsOrderTaxiRailyDraftFactory = {
  create,
};

export default billingsOrderTaxiRailyDraftFactory;
